import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    Typography,
    Box,
    Divider,
    ThemeProvider
} from "@mui/material";
import { UserApi } from '../../../services/api';
import { useAuth } from '../../context/AuthContext';
import { darkTheme } from '../../../theme/darkTheme';

const DataErk = ({ openErk, setOpenErk, mode = "accept" }) => {

    const { nutzer } = useAuth();

    const handleAccept = async () => {
        try {
            if (nutzer && nutzer.id) {
                await UserApi.setErkStatus({ id: nutzer.id });
                setOpenErk(false);
                // Optional: Fenster neu laden oder Status im Context updaten
                window.location.reload();
            }
        } catch (err) {
            console.error('Fehler beim Speichern der Zustimmung:', err);
        }
    };

    return (
        <ThemeProvider theme={darkTheme}>
            <Dialog
                onClose={(event, reason) => {
                    // Verhindert das Schließen durch Klicken neben das Modal, wenn akzeptiert werden muss
                    if (mode === "accept" && reason && reason === "backdropClick") return;
                    if (mode === "accept" && reason && reason === "escapeKeyDown") return;
                    setOpenErk(false);
                }}
                open={openErk}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        bgcolor: 'background.paper',
                        borderRadius: '16px',
                        border: '1px solid rgba(59, 130, 246, 0.2)',
                    }
                }}
            >
                <DialogTitle sx={{ fontWeight: 700, color: 'primary.main', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                    Datenschutzerklärung
                </DialogTitle>
                <DialogContent sx={{ mt: 2, color: 'text.primary', '& h6': { mt: 3, mb: 1, color: '#e0f2fe', fontWeight: 600 } }}>
                    <Box sx={{ pb: 2 }}>
                        <Typography variant="body2" paragraph>
                            Zuletzt aktualisiert: Heute
                        </Typography>

                        <Typography variant="body2" paragraph>
                            Wir freuen uns über Ihr Interesse an unserer GymApp. Der Schutz Ihrer persönlichen Daten ist uns ein sehr wichtiges Anliegen. Nachfolgend informieren wir Sie ausführlich über den Umgang mit Ihren Daten.
                        </Typography>

                        <Typography variant="h6">1. Verantwortlicher</Typography>
                        <Typography variant="body2" paragraph>
                            Verantwortlicher für die Datenverarbeitung im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br />
                            Philipp Feld<br />
                            Mainstraße 7<br />
                            49809 Lingen
                        </Typography>

                        <Typography variant="h6">2. Welche Daten wir erfassen</Typography>
                        <Typography variant="body2" paragraph>
                            Wir verarbeiten personenbezogene Daten, die Sie uns bei der Registrierung und Nutzung der App freiwillig zur Verfügung stellen. Dazu gehören:
                        </Typography>
                        <Box component="ul" sx={{ pl: 2, typography: 'body2' }}>
                            <li><strong>Stammdaten:</strong> Vorname, Nachname, E-Mail-Adresse, Passwort (verschlüsselt).</li>
                            <li><strong>Körper- und Gesundheitsdaten (optional):</strong> Alter/Geburtsdatum, Geschlecht, Körpergröße, Startgewicht, aktuelles Gewicht, Zielgewicht. Diese Daten sind für die Erstellung personalisierter Trainingspläne erforderlich.</li>
                            <li><strong>Trainingsdaten:</strong> Erstellte Trainingspläne, durchgeführte Workouts, Gewichte, Wiederholungen, eigene Übungen.</li>
                            <li><strong>Interaktionsdaten:</strong> Gruppenmitgliedschaften, Kommentare in Gruppen, Feedback an die Entwickler.</li>
                        </Box>

                        <Typography variant="h6">3. Zweck der Datenverarbeitung</Typography>
                        <Typography variant="body2" paragraph>
                            Wir verarbeiten Ihre Daten ausschließlich für folgende Zwecke:
                        </Typography>
                        <Box component="ul" sx={{ pl: 2, typography: 'body2' }}>
                            <li>Bereitstellung und Betrieb der GymApp.</li>
                            <li>Verwaltung Ihres Benutzerkontos und sichere Authentifizierung (mittels JSON Web Token).</li>
                            <li>Auswertung und Darstellung Ihrer Trainingsfortschritte.</li>
                            <li>Kommunikation und Interaktion innerhalb von Gruppen (Chat/Kommentar-Funktionen).</li>
                            <li>Versand von Push-Benachrichtigungen (nur bei ausdrücklicher Einwilligung).</li>
                        </Box>

                        <Typography variant="h6">4. Rechtsgrundlage der Verarbeitung</Typography>
                        <Typography variant="body2" paragraph>
                            Die Verarbeitung Ihrer Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), Art. 6 Abs. 1 lit. b DSGVO (Erfüllung eines Vertrags) sowie Art. 9 Abs. 2 lit. a DSGVO (ausdrückliche Einwilligung zur Verarbeitung von Gesundheitsdaten).
                        </Typography>

                        <Typography variant="h6">5. Weitergabe von Daten</Typography>
                        <Typography variant="body2" paragraph>
                            Ihre Daten werden auf sicheren Servern (MySQL Datenbank) gespeichert. Eine Weitergabe an Dritte erfolgt nicht, es sei denn, dies ist zur Bereitstellung der Dienste zwingend erforderlich (z.B. Hosting-Provider) oder wir sind gesetzlich dazu verpflichtet.
                        </Typography>

                        <Typography variant="h6">6. Datensicherheit</Typography>
                        <Typography variant="body2" paragraph>
                            Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen Manipulation, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen. Ihre Passwörter werden mittels modernster Hashing-Verfahren (bcrypt) unkenntlich gemacht. Die Übertragung von Daten erfolgt verschlüsselt.
                        </Typography>

                        <Typography variant="h6">7. Ihre Rechte</Typography>
                        <Typography variant="body2" paragraph>
                            Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu können Sie sich jederzeit an die oben angegebene Adresse wenden.
                        </Typography>
                        <Button
                            onClick={handleAccept}
                            variant="contained"
                            color="primary"
                            fullWidth
                            sx={{ fontWeight: 700, borderRadius: '8px' }}
                        >
                            Ich habe die Datenschutzerklärung gelesen und stimme zu
                        </Button>
                    </Box>
                </DialogContent>
                <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)' }} />
            </Dialog >
        </ThemeProvider >
    );
};

export default DataErk;